import { GlobalDataLayerService } from "./global-data-layer-service";
import { EventActions } from "../../utility/constants";
import { DataLayerEventBuilder } from "./global-data-layer-event-builder";

export function sendDataLayerEventShoppingCart(
  elementId: string,
  elementName: string,
  url?: string,
): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.CONTEXTUAL_BUTTON_CLICK,
    {
      componentClick: {
        clickElementId: elementId,
        clickElementName: elementName,
        ...(url && { targetUrl: url }),
      },
    },
  );
}
export function pushLevel0IconClickEvent(
  url: string,
  elementId: string,
  elementName: string,
): void {
  const event = new DataLayerEventBuilder();
  event.withAction(EventActions.PCOM_SEARCH_CLICK);
  event.withComponentClick({
    clickElementId: elementId,
    clickElementName: elementName,
    targetUrl: url,
  });
  event.pushEvent();
}
